import "./style.scss";
import { useMemo, useState } from "react";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import { Countries } from "@/src/constants/globalConsts";
import { SidebarSvgExportConst } from "@/src/svg/sidebar/SidebarSvgExport";

type Props = {
  value: string;
  groupKey: string;
  columnID: string;
  onChange: (value: string) => void;
};

const CountryCell = ({ value, groupKey, columnID, onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedCountry, setSelectedCountry] = useState<string | null>(value);

  const filteredCountries = useMemo(() => {
    return Countries.filter((country) => country.toLowerCase().includes(search.toLowerCase()));
  }, [search]);

  const handleOpen = () => {
    setIsOpen(true);
    setSelectedCountry(value);
  };

  const handleOk = () => {
    if (selectedCountry) {
      onChange(selectedCountry);
    }
    setSearch("");
    setIsOpen(false);
    console.log(`current user id: ${localStorage.getItem("userID")}`);
    console.log(`current column id: ${groupKey} - ${columnID}`);
    console.log(`current country: ${selectedCountry}`);
  };

  const handleCancel = () => {
    setSearch("");
    setSelectedCountry(value);
    setIsOpen(false);
  };

  return (
    <>
      <p>{value}</p>
      <div className="cell-content-edit" onClick={handleOpen}>
        <SidebarSvgExportConst.CustomizationSvg />
      </div>

      {isOpen && (
        <div className="cell-content-popup-country">
          <div className="cell-content-popup-country-title">
            <p>Select country</p>
          </div>
          <div className="cell-content-popup-country-search">
            <input type="text" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="cell-content-popup-country-list">
            <ul className="cell-content-popup-country-ul">
              {filteredCountries.map((country) => (
                <li key={country} className="cell-content-popup-country-li">
                  <label className="cell-content-popup-country-li-label">
                    <input type="checkbox" checked={selectedCountry === country} onChange={() => setSelectedCountry(country)} />
                    <span className="checkmark"></span>
                  </label>
                  <span>{country}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="cell-content-popup-country-buttons">
            <BtnDefault onClick={handleOk}>
              <p>Ok</p>
            </BtnDefault>
            <BtnDefault onClick={handleCancel}>
              <p>Cancel</p>
            </BtnDefault>
          </div>
        </div>
      )}
    </>
  );
};

export default CountryCell;
